<template>
  <div>
    <Header theme="123"></Header>
    <div class="container">

        <div class="tabContent">

            <template v-if="Tabactive === 1">
              <div class="applyBtn"><a href="https://snms.idshanxi.com/" target="_blank">申请入口</a></div>
              <div class="zdbz">指导步骤</div>
              <div class="content">
                <div class="timeline">
                  <div class="leftLine">
                    <div v-for="(item, index) in tab2Data" :key="index">
                      <div class="one" :class="{'active':active==index}" @mouseover="mouseOver(index)" @mouseleave="mouseLeave">
                        0{{index + 1}}</div>
                      <div class="line" :class="{'active':active==index}">
                        <div v-if="index == 2" class="sj" :class="{'sj1':active==2}"></div>
                      </div>
                    </div>
                  </div>
                  <div class="rightLine">
                    <div v-for="(item, index) in tab2Data" :key="index">
                      <div class="one" @mouseover="mouseOver(index)" @mouseleave="mouseLeave()"
                        :class="[{'activeBG':active==index}, 'item' + index]">
                        <div class="title">
                          <img v-if="index == 0"
                            :src="active == 0 ? require('../../assets/images/011@2x.png') : require('../../assets/images/01@2x.png')"
                            width="38px" height="46px">
                          <img v-if="index == 1"
                            :src="active == 1 ? require('../../assets/images/022@2x.png') : require('../../assets/images/02@2x.png')"
                            width="48px" height="48px">
                          <img v-if="index == 2"
                            :src="active == 2 ? require('../../assets/images/033@2x.png') : require('../../assets/images/03@2x.png')"
                            width="47px" height="46px">
                          <span :class="{'active1':active==index}">{{item.title}}</span>
                        </div>
                        <div class="text" :class="{'active1':active==index}">
                          {{item.contentTitle}}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="img">
                  <img src="../../assets/images/IMG@2x.png" width="675px" height="782px">
                </div>
              </div>
            </template>
        </div>
    </div>
    <Contact />
    <Footer />
  </div>
</template>

<script>
  import Header from '@/components/Header.vue'
  import Footer from '@/components/Footer.vue'
  import { fetchIntroduceByType, contentByType } from '@/api/api.js'
  import {serverUrl} from '@/utils/server.js'
  import Contact from './Contact.vue'

  export default {
    data() {
      return {
        Tabactive: 1,
        tabList:[
          {
              name: '节点介绍'
          },
          {
              name: '企业上节点'
          },
        ],
        tabData: null,
        baseUrl: serverUrl.baseURL,
        tab2Data: null,
        active: null,
      }
    },
    components: {
      Header,
      Footer,
      Contact
    },
    mounted() {
        this.getTabData()
        this.getTab2Data()
    },
    methods: {
        goHome(num) {
          if(num === 1) {
            this.$router.push({
              path: '/Home'
            })
          }else if(num === 2){
            this.$router.push({
              path: '/Home',
              query: {
                id: 'node'
              }
            })
          }
        },
        tabChange(index) {
            this.Tabactive = index
        },
        getTabData() {
          let params = {
            type: 5
          }
          // type: 1二级节点介绍 2建设指导 3建设咨询 4运营管理 5企业节点介绍 6企业上节点 7节点建设
          fetchIntroduceByType(params).then(res => {
            this.tabData = res.data
          })
        },
        getTab2Data() {
           contentByType({
              type: 6
            }).then(res => {
              this.tab2Data = res.data
            })
        },
        mouseOver(index) {
          this.active = index
          console.log(index)
        },
        mouseLeave() {
          this.active = null
        },
    }
  }
</script>

<style scoped>
.crumbs{
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #909DB1;
    padding: 50px 0 30px 0px;
    margin-top: 108px;
}
.crumbs span {
  cursor: pointer;
}
.curLink{
    color: rgba(18, 30, 48, 1);
}
.container{
    width: 1400px;
    /* border: 1px solid #f00; */
    margin: 0 auto;
    padding-top: 100px;
}
.nodeTab{
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #909DB1;
    border-bottom: 1px solid rgba(218, 223, 231, 1);
    display: flex;
    align-items: center;
    margin-top: 15px;
}
.nodeTab span {
    font-size: 20px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    line-height: 32px;
    color: #909DB1;
    padding: 0 20px;
    cursor: pointer;
    display: block;
    padding-bottom: 15px;
    border-bottom: 3px solid transparent;
}
.nodeTab .activeTab{
    color: rgba(15, 94, 255, 1);
    border-bottom: 3px solid rgba(15, 94, 255, 1);
}
.tabContent{
    padding: 47px 60px 20px;
}
.tabContent .info {
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    line-height: 32px;
}
.buildImg{
    width: 100%;
    height: 302px;
    margin-top: 30px;
}
.infoP{
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #121E30;
    line-height: 32px;
}
.introduceImg{
    width: 638px;
    display: block;
    margin: 0 auto;
    height: 431px;
}
.content {
    width: 1337px;
    display: flex;
    justify-content: space-between;
    margin: 50px auto 80px;
  }

  .timeline {
    width: 1300px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    height: 782px;
    margin-right: 45px;
  }

  .word {
    width: 1300px;
    margin: 0 auto;
  }

  .zdbz {
    margin-top: 60px;
    text-align: center;
    font-size: 32px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
  }

  .leftLine {
    width: 70px;
    margin-right: 20px;
  }

  .leftLine .one,
  .leftLine .two,
  .leftLine .three {
    width: 70px;
    height: 70px;
    text-align: center;
    line-height: 70px;
    font-size: 30px;
    font-family: Arial;
    font-weight: bold;
    color: #FFFFFF;
    background: #B3B3B3;
    border-radius: 50%;
    cursor: pointer;
  }

  .active {
    background: #0F5BE8 !important;
  }

  .line {
    width: 2px;
    height: 166px;
    background: #B3B3B3;
    margin: 10px auto;
    position: relative;
  }

  .rightLine .one,
  .rightLine .two,
  .rightLine .three {
    padding: 40px 60px;
    box-sizing: border-box;
    width: 601px;
    height: 222px;
    cursor: pointer;
    margin-bottom: 45px;
  }

  .item0 {
    background: url(../../assets/images/one@2x.png) top center no-repeat;
    background-size: cover;
  }

  .activeBG {
    background: url(../../assets/images/hover@2x.png) top center no-repeat !important;
    background-size: cover;
  }

  .item1 {
    margin-top: 40px;
    background: url(../../assets/images/two@2x.png) top center no-repeat;
    background-size: cover;
  }

  .item2 {
    margin-top: 50px;
    background: url(../../assets/images/three@2x.png) top center no-repeat;
    background-size: cover;
  }

  .img {
    height: 782px;
  }

  .rightLine .one img {
    margin-right: 20px;
    /* width: 38px;
    height: 46px; */
  }

  .rightLine .two img {
    margin-right: 20px;
    /* width: 48px;
    height: 48px; */
  }

  .rightLine .three img {
    margin-right: 20px;
   /* width: 47px;
    height: 46px; */
  }

  .rightLine span {
    font-size: 30px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #333333;
  }

  .rightLine .title {
    display: flex;
    align-items: center;
  }

  .rightLine .text {
    margin-top: 20px;
    font-size: 18px;
    font-family: Source Han Sans CN;
    font-weight: 300;
    color: #7D889B;
    line-height: 26px;
  }

  .active1 {
    color: #fff !important;
  }

  .threeLine {
    position: relative;
  }

  .sj {
    position: absolute;
    width: 0px;
    height: 0px;
    border: 5px solid transparent;
    border-top-color: #B3B3B3;
    bottom: -10px;
    left: -4px;
  }

  .sj1 {
    border-top-color: #0F5BE8 !important;
  }
  .applyBtn{
    border-radius: 30px;
    color: #fff;
    font-size: 14px;
    background: #0F5BE8;
    cursor: pointer;
    width: 130px;
    color: #fff;
  }
  .applyBtn a {
    display: block;
    color: #fff;
    padding: 15px 35px;
  }
</style>



// WEBPACK FOOTER //
// src/views/node/UpperNode.vue